module.exports = "https://static.moomoo.com/components/top-trading-signals/images/ai_analyst_icon.8d68aa9ca2.png";